
const initialState = {
  customizedForm: JSON.parse(localStorage.getItem('customizedForm')) || {},
  allPolicies: [],
  error: null,
  allDetailPolicy: {},              // <— prefer object; you read props on it elsewhere
  getPolicy: [],
  search_policy_list: [],
  policy_premium: [],
  saved_customer_list: [],
  get_vehicle_premium: [],
  saved_policy_data: null,
  coverages:{
    content: [],
    totalElements: 0,
    totalPages: 0,
    number: 0,
    size: 5,
  },

  // NEW: remember last-known pages/sizes per section
  pagination: {
    driver:      { page: 0, size: 5 },
    vehicle:     { page: 0, size: 5 },
    coverage:    { page: 0, size: 5 },   // or 'transaction' if that’s what your API uses
    transaction: { page: 0, size: 5 },
  },

  premiumVehicles: {
    content: [],
    totalElements: 0,
    totalPages: 0,
    number: 0,
    size: 5,
  },
};


  const policyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_POLICY_SUCCESS':
      return { ...state, allPolicies: action.payload, error: null };

    case 'GET_DETAIL_POLICY_SUCCESS': {
      const { section, page, size } = action.meta || {};
      const nextPagination = (section && Number.isFinite(page) && Number.isFinite(size))
        ? { ...state.pagination, [section]: { page, size } }
        : state.pagination;

      return { ...state, allDetailPolicy: action.payload, pagination: nextPagination, error: null };
    }

    case "DELETE_DRIVER_SUCCESS":
      return {
        ...state,
        allDetailPolicy: action.payload,
        error: null,
      };

    case "DELETE_VEHICLE_SUCCESS":
      return {
        ...state,
        allDetailPolicy: action.payload,
        error: null,
      };

    case "GET_PREMIUM_VEHICLES_SUCCESS":
      return {
        ...state,
        premiumVehicles: action.payload || initialState.premiumVehicles,
        error: null,
      };
      case "GET_COVERAGE_LIST_SUCCESS":
      return {
        ...state,
        coverages: action.payload || initialState.coverages,
        error: null,
      };

    case "GET_PREMIUM_VEHICLES_FAILURE":
      return { ...state, error: action.payload };

    case 'ADD_NOT_BUTTON_SUCCESS':
      return { ...state, saved_policy_data: action.payload, error: null };

    case 'GET_POLICY_BY_ID_SUCCESS':
      return { ...state, getPolicy: action.payload, error: null };

    case 'SEARCH_POLICY_LIST_SUCCESS':
      return { ...state, search_policy_list: action.payload, error: null }; // fixed typo

    case 'GET_POLICY_PREMIUM_DETAIL_SUCCESS':
      return { ...state, policy_premium: action.payload, error: null };

    case 'GET_SAVED_CUSTOMER_LIST_SUCCESS':
      return { ...state, saved_customer_list: action.payload, error: null };

    case 'GET_VEHICLE_DETAIL_PREMIUM_BY_ID_SUCCESS':
      return { ...state, get_vehicle_premium: action.payload, error: null };

    case 'SAVE_POLICY_SUCCESS':
      localStorage.setItem('customizedForm', JSON.stringify(action.payload));
      return {
        ...state,
        customizedForm: action.payload,
        clientCustomerId: action.payload.clientCustomerId,
        error: null
      };

    case 'UPDATE_POLICY_SUCCESS':
      return { ...state, getPolicy: action.payload, error: null };

    case 'DELETE_POLICY_SUCCESS': {
      const updatedPolicies = state.allPolicies.filter(p => p.id !== action.payload);
      return { ...state, allPolicies: updatedPolicies, error: null };
    }

    case 'GET_POLICY_FAILURE':
    case 'SAVE_POLICY_FAILURE':
    case 'DELETE_POLICY_FAILURE':
    case 'GET_DETAIL_POLICY_FAILURE':
    case 'UPDATE_POLICY_FAILURE':
    case 'GET_POLICY_PREMIUM_DETAIL_FAILURE':
    case 'GET_SAVED_CUSTOMER_LIST_FAILURE':
      return { ...state, error: action.payload };

    default:
      return state;
  }
};


  export default policyReducer;
